module.exports = __webpack_public_path__ + "static/media/blankpage.cf4e3d09.jpg";